import { render, staticRenderFns } from "./IconForm.vue?vue&type=template&id=42c2d383&"
import script from "./IconForm.vue?vue&type=script&lang=js&"
export * from "./IconForm.vue?vue&type=script&lang=js&"
import style0 from "./IconForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports